<template>
  <div class="form-check">
    <label class="form-check-label">
      <div class="uniform-checker" @click="toggleCheck">
        <span :class="{ checked: isChecked }">
          <slot></slot>
        </span>
      </div>
      <span v-html="labelText"></span> 
    </label>
  </div>
</template>

<script>
export default {
  name: "GSCheckbox",
  props: {
    labelText: {
      type: String
    },
  },
  data: function () {
    return {
      isChecked: false,
    };
  },
  methods: {
    toggleCheck: function () {
      this.isChecked = !this.isChecked;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/GSCheckbox.vue